import React from 'react'
import { connect } from 'dva'
import { framework_tool, component_tool, utils_tool } from '@/tool'
import { modelUtils } from '@/utils'
const { WizSpin, WizCard, WizForm, WizRow, WizCol, WizButton } = component_tool
const { WizContainer } = framework_tool
const { Session } = utils_tool

const findParamRecord = (history) => {
    let record = {}
    if (history.location && history.location.pathname === '/integrationCounseling/manager/antecedentIntervention/salesOpening/examine') {
        if (history.location && history.location.record) {
            record = history.location.record
            Session.set('salesOpeningExamine', record)
        } else {
            record = Session.get('salesOpeningExamine') || {}
        }
    }
    if (history.location && history.location.pathname === '/integrationCounseling/manager/antecedentIntervention/afterOpening/examine') {
        if (history.location && history.location.record) {
            record = history.location.record
            Session.set('afterOpeningExamine', record)
        } else {
            record = Session.get('afterOpeningExamine') || {}
        }
    }
    return record
}

class SalesOpeningExamine extends WizContainer {

    componentName = 'SalesOpeningExamine'

    constructor(props) {
        super(props)
        let record = findParamRecord(props.history)
        this.state = {
            record
        }
    }

    _componentDidMount() {
        this._detail()
    }

    _detail = () => {
        const { processContentId } = this.state.record
        this.doAction({
            path: 'counselingProcess/salesOpeningDetail',
            payload: {
                key: 'salesOpeningDetail@' + processContentId,
                apiParams: {
                    tutorContentId: processContentId
                }
            }
        })
    }

    _onSub = () => {
        const { processContentId } = this.state.record
        this.refs.form.validateFields((err, values) => {
            if (!err) {
                let { auditState, comment } = values
                let params = {
                    auditState, 
                    comment,
                    tutorContentId: processContentId
                }
                this.doAction({
                    path: 'counselingProcess/salesOpeningAudit',
                    payload: {
                        key: 'salesOpeningAudit@' + processContentId,
                        apiParams: params
                    }
                })
            }
        })
    }
    
    propsAndStateOnChange = {
        save: this._saveOnChange.bind(this)
    }

    _saveOnChange(nextProps, nextState) {
        if (nextProps.save.code === 1) {
            wizNotice.success('操作成功')
            this.jumpPage('goBack')
        } else {
            wizNotice.error(nextProps.save.msg)
        }
    }

    _renderFooter = () => {
        return (
            <WizRow className='form-btns row-item'>
                <WizCol span={24}>
                    <WizButton type='primary' onClick={() => this._onSub()}>{'确认'}</WizButton>
                </WizCol>
            </WizRow>
        )
    }

    render() {
        let { moduleType } = this.state.record
        let { detail } = this.props
        let infoProps = {
            ref: 'info',
            columns: [{
                title: moduleType === 0 ? '销售系统截图' : '售后系统截图',
                name: 'fileId',
                dataIndex: 'fileId',
                formItem: {
                    type: 'custom',
                    render: (r, f) => {
                        let url = r && r.fileId ? getOssFilePath(r.fileId) : ''
                        let fileName = r && r.fileName ? r.fileName : ''
                        return <a href={url} style={{ color: '#1890ff' }}>{fileName}</a>
                    }
                }
            }],
            record: detail.data,
            preview: null,
            footer: null,
            formItemLayout: {
                labelCol: { span: 4 },
                wrapperCol: { span: 17 }
            },
            style: { maxWidth: '100%', width: '100%' }
        }

        let columns = [{
            title: '审核结果',
            name: 'auditState',
            dataIndex: 'auditState',
            dict: [
                { code: 0, codeName: '不合格' },
                { code: 1, codeName: '合格' }
            ],
            formItem: {
                type: 'select',
                style: { maxWidth: 300 },
                rules: [{ required: true, message: '请选择审核结果' }]
            }
        }, {
            title: '审核意见',
            name: 'comment',
            dataIndex: 'comment',
            formItem: {
                type: 'textarea',
                maxLength: 100,
                autoSize: { minRows: 4, maxRows: 8 },
                rules: [{ required: true, message: '请输入审核意见' }]
            },
        }]
        let formProps = {
            ref: 'form',
            columns,
            record: detail.data,
            preview: null,
            footer: this._renderFooter(),
            formItemLayout: {
                labelCol: { span: 4 },
                wrapperCol: { span: 17 }
            },
            style: { maxWidth: '100%', width: '100%' }
        }
        return (
            <WizSpin spinning={false} >
                <WizCard title={`${moduleType === 0 ? '销售' : '售后'}系统开通`}>
                    <WizForm {...infoProps} />
                </WizCard>
                <WizCard title='审核'>
                    <WizForm {...formProps} />
                </WizCard>
            </WizSpin>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    const { counselingProcess } = state
    const { processContentId } = findParamRecord(ownProps.history)
    const detail = modelUtils.getModelEntity(counselingProcess, 'salesOpeningDetail@' + processContentId)
    const save = modelUtils.getModelEntity(counselingProcess, 'salesOpeningAudit@' + processContentId)
    const loading = modelUtils.getLoadingState(state, 'counselingProcess')
    return {
        detail,
        save,
        ...loading
    }
}

export default connect(mapStateToProps)(SalesOpeningExamine)


